import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { useState, useEffect } from "react";
import Login from "./pages/login";
import Home from "./pages/homepage";
import ErrorPG from "./pages/error";
import Bookmarks from "./pages/bookmarks";
import Explore from "./pages/explore";
import Newpost from "./pages/newpost";
import About from "./pages/about";
import Profile from "./pages/profile";
import Other from "./pages/others";
import Category from "./pages/category";
import Account from "./pages/account";
import SinglePost from "./pages/SinglePost";
import { UserAuth } from "./context/authContext";
import PropagateLoader from "react-spinners/PropagateLoader";

export default function App() {
  const { user } = UserAuth();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  //if the user is logged in render the child component else redirect the "not logged in user" to login page
  const RequireAuth = ({ children }) => {
    return user ? children : <Navigate to="/login" />;
  };

  return (
    <div>
      {loading ? (
        <div className="appStyle">
          <PropagateLoader
            color={"#FE3F3F"}
            loading={loading}
            size={25}
            speedMultiplier={1.25}
          />
        </div>
      ) : (
        <Router>
          <Routes>
            <Route path="/">
              <Route path="login" element={<Login />} />
              <Route
                path=""
                index
                element={
                  <RequireAuth>
                    {" "}
                    <Login />{" "}
                  </RequireAuth>
                }
              />
              <Route path="homepage">
                <Route
                  index
                  element={
                    <RequireAuth>
                      <Home />
                    </RequireAuth>
                  }
                />
              </Route>
              <Route path="explore">
                <Route
                  index
                  element={
                    <RequireAuth>
                      {" "}
                      <Explore />{" "}
                    </RequireAuth>
                  }
                />
              </Route>
              <Route path="explore/:type">
                <Route
                  index
                  element={
                    <RequireAuth>
                      {" "}
                      <Category />{" "}
                    </RequireAuth>
                  }
                />
              </Route>
              <Route path="post/:type">
                <Route
                  index
                  element={
                    <RequireAuth>
                      {" "}
                      <SinglePost />{" "}
                    </RequireAuth>
                  }
                />
              </Route>
              <Route path="bookmarks">
                <Route
                  index
                  element={
                    <RequireAuth>
                      {" "}
                      <Bookmarks />{" "}
                    </RequireAuth>
                  }
                />
              </Route>
              <Route path="create-post">
                <Route
                  index
                  element={
                    <RequireAuth>
                      {" "}
                      <Newpost />{" "}
                    </RequireAuth>
                  }
                />
              </Route>
              <Route path="aboutus">
                <Route
                  index
                  element={
                    <RequireAuth>
                      {" "}
                      <About />{" "}
                    </RequireAuth>
                  }
                />
              </Route>
              <Route path="profile">
                <Route
                  index
                  element={
                    <RequireAuth>
                      {" "}
                      <Profile />{" "}
                    </RequireAuth>
                  }
                />
              </Route>
              <Route path="profile/:type">
                <Route
                  index
                  element={
                    <RequireAuth>
                      {" "}
                      <Other />{" "}
                    </RequireAuth>
                  }
                />
              </Route>
              <Route path="account">
                <Route
                  index
                  element={
                    <RequireAuth>
                      <Account />
                    </RequireAuth>
                  }
                />
              </Route>
              <Route path=":type">
                <Route index element={<ErrorPG />} />
              </Route>
            </Route>
          </Routes>
        </Router>
      )}
    </div>
  );
}
